var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.2,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "black",
    d: "M14.307,8.65l-4.054,3.15l-3.1345e-08,2.44903e-08c-0.1088,0.085007 -0.128088,0.242119 -0.0430811,0.350919c0.0125503,0.0160631 0.0270181,0.0305309 0.0430812,0.0430812l4.054,3.153l2.56749e-08,1.99725e-08c0.121872,0.094804 0.193107,0.240596 0.193,0.395v2.688l5.3258e-09,-1.47915e-05c-9.53428e-05,0.276142 -0.22403,0.499923 -0.500173,0.499827c-0.116863,-4.03488e-05 -0.23002,-0.0410136 -0.319816,-0.115803l-7.72001,-6.43001l2.81261e-08,2.34549e-08c-0.212077,-0.176855 -0.24063,-0.492148 -0.0637751,-0.704225c0.0192937,-0.0231362 0.0406389,-0.0444814 0.0637751,-0.0637751l7.72,-6.433l5.07154e-08,-4.22422e-08c0.212181,-0.176731 0.527456,-0.147993 0.704187,0.0641875c0.0747921,0.0897943 0.115769,0.20295 0.115812,0.319813v2.688l1.14149e-09,1.64911e-06c0.000106621,0.154404 -0.071129,0.300196 -0.193001,0.394999Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7ae7d9edd477441acdcb4180da28896a.svg";
export { ForwardRef as ReactComponent };